/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from 'react'
import {
  Header,
  Footer,
  Product,
  Loading,
  Paginate,
} from '../../components/index'
import { Col, Row } from 'react-bootstrap'
import { WebApi } from '../../api/web'
import { BsCloudDownload } from 'react-icons/bs'
import { FiBox } from 'react-icons/fi'
const Shop = () => {
  const [products, setProducts] = useState(null)
  const [isDownloadable, setIsDownload] = useState(null)
  const [loading, setLoading] = useState(false)
  const [countDownload, setCountDownload] = useState(0)
  const [countPhysical, setCountPhysical] = useState(0)
  const [totalPage, setTotalPage] = useState(1)
  const [page, setPage] = useState(1)

  useEffect(() => {
    ProductList()
  }, [page])
  const ProductList = async () => {
    let isDownload = 0
    let isPhysical = 0
    setLoading(true)
    await WebApi.productList(page, isDownloadable)
      .then((res) => {
        setProducts(res.data.data.productList.list)
        setTotalPage(res.data.data.productList.totalPages)
        for (var i in res.data.data.productList.list) {
          if (res.data.data.productList.list[i].isDownloadable) {
            isDownload += 1
          } else {
            isPhysical += 1
          }
        }
        setCountDownload(isDownload)
        setCountPhysical(isPhysical)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }
  useEffect(() => {
    SelectProductList()
  }, [isDownloadable])

  const SelectProductList = async () => {
    setLoading(true)
    await WebApi.productList(page, isDownloadable)
      .then((res) => {
        setProducts(res.data.data.productList.list)
        setTotalPage(res.data.data.productList.totalPages)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }
  return (
    <>
      <Header title='فروشگاه اینترنتی' />
      <div className='container'>
        {loading && <Loading />}
        <div className='template-pages'>
          {products ? (
            <>
              <div className='sort-button-shop'>
                <div
                  className={`nav ${isDownloadable == true ? 'active' : ''}`}
                  onClick={() => setIsDownload(true)}
                >
                  <div>
                    <BsCloudDownload size={35} />
                  </div>
                  <div className='item'>
                    <h5>قابل دانلود</h5>
                    <span>{countDownload} فایل جدید</span>
                  </div>
                </div>
                <div
                  className={`nav ${isDownloadable == false ? 'active' : ''}`}
                  onClick={() => setIsDownload(false)}
                >
                  <div>
                    <FiBox size={35} />
                  </div>
                  <div className='item'>
                    <h5>قابل ارسال</h5>
                    <span>{countPhysical} محصول جدید</span>
                  </div>
                </div>
              </div>
              <Row>
                {products.map((product) => (
                  <Col md={6}>
                    <Product
                      name={product.title}
                      caption={product.category.title}
                      price={product.finalPrice}
                      img={product.image}
                      link={`/product/${product._id}`}
                    />
                  </Col>
                ))}
              </Row>
              <Paginate {...{ totalPage, page, setPage }} />
            </>
          ) : (
            <Loading />
          )}
        </div>
      </div>
      <Footer />
    </>
  )
}
export default Shop
